import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Constants} from "../../constants";
import {environment} from "../../environments/environment";

@Injectable({
    providedIn: 'root'
})
export class OrderService {

    constructor(private http: HttpClient) {}

    getPublicRequestHeaders() {
        return new HttpHeaders({
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': environment.publicApiToken,
        });
    }

    getRequestHeaders() {
        return new HttpHeaders({
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': localStorage.getItem(Constants.LOCAL_TOKEN) ?? environment.publicApiToken
        });
    }

    get(params: any) {
        return this.http.get(environment.apiUrl + '/orders', {params: params, headers: this.getRequestHeaders()});
    }

    getById(id: string) {
        return this.http.get(environment.apiUrl + '/orders/' + id, {headers: this.getRequestHeaders()});
    }

    create(order: any) {
        return this.http.post(environment.publicApiUrl + '/orders', order, {headers: this.getPublicRequestHeaders()});
    }

    update(id: string, order: any) {
        return this.http.put(environment.apiUrl + '/orders/' + id, order, {headers: this.getRequestHeaders()});
    }

    delete(id: string) {
        return this.http.delete(environment.apiUrl + '/orders/' + id, {headers: this.getRequestHeaders()});
    }
}
